import React from 'react';
import AdminThankYouImage from 'images/signups/card/admin-card.png';
import BrandMomentCard from 'react/signups/card/common/BrandMomentCard';

export default function AdministratorCard() {
  const caption = 'You are the Card Administrator';
  const copy = 'You will have access to:';
  const listItems = [
    'Set 50+ spending rules for how the card can be used',
    'Fund the card',
    'See all purchases and receive customizable alerts',
  ];

  return (
    <BrandMomentCard
      cardCaption={caption}
      cardCopy={copy}
      cardListItems={listItems}
      imgAlt="Administrator Thank You"
      imgSrc={AdminThankYouImage}
    />
  );
}
